import { useAdvancedApmRum } from '@wsb/gasket-advanced-apm-rum/client';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorCatchFallback } from './ErrorCatchFallback';

export const ErrorCatch = ({ children }: React.PropsWithChildren<unknown>) => {
  const rumClient = useAdvancedApmRum();
  return (
    <ErrorBoundary
      FallbackComponent={ErrorCatchFallback}
      onError={error => {
        console.error('ErrorBoundary', error);
        rumClient?.captureError(error);
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
